import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import './UserProfileLogout.scss';
import { NO_OP } from '../../constants/Constants';
const UserProfileLogout = props => {
  const {
    onLogout,
    disableLogoutButton
  } = props;
  return /*#__PURE__*/React.createElement(Button, {
    className: "logout-icon",
    disabled: disableLogoutButton,
    onClick: onLogout
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-exit"
  }), __('Logout'));
};
UserProfileLogout.propTypes = {
  onLogout: PropTypes.func,
  disableLogoutButton: PropTypes.bool
};
UserProfileLogout.defaultProps = {
  onLogout: NO_OP,
  disableLogoutButton: false
};
export default UserProfileLogout;